import { render } from "./material-apoio4.vue?vue&type=template&id=af0c2ad0"
import script from "./material-apoio4.vue?vue&type=script&lang=js"
export * from "./material-apoio4.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__